// extracted by mini-css-extract-plugin
module.exports = {"item":"item-2_NBI","name":"name-iVu-Y","close":"close-1n9t3"};